import React from 'react';
import { Button } from '@progress/kendo-react-buttons';
import { useGlobalizationContext, useTranslation, useUiAdminConfigsContext } from '@cs-cms/state-management';
import { CpsReportIssueState, ABOUT_ADDED_TEXT, REPORT_ISSUE_BUTTON_LABEL } from '@cs-cms/types';

export const FixedContentPreview: React.FC = () => {
  const { selectedLocale } = useGlobalizationContext();
  const { translate } = useTranslation(selectedLocale);
  const { uiAdminConfigState } = useUiAdminConfigsContext();
  const reportIssueState = uiAdminConfigState.reportIssue as CpsReportIssueState;

  const fixedContentDescription = translate('custom.settings.itAdminCenter.aboutPageEditor.fixedContentDescription');

  return (
    <>
      <p>{fixedContentDescription}</p>

      <div className="fixedContentPreviewBox">
        <p>{ABOUT_ADDED_TEXT}</p>

        <Button
          themeColor="primary"
          onClick={() =>
            window.open(
              `mailto:${reportIssueState.emailRecipient || ''}?subject=${reportIssueState.emailSubject || ''}&body=${reportIssueState.emailBody || ''}`
            )
          }
        >
          {REPORT_ISSUE_BUTTON_LABEL}
        </Button>
      </div>
    </>
  );
};
